import React, {Component, Fragment} from 'react';

import classNames from 'classnames';
import {generateId} from '../../shared/utils';
import i18n from '../../shared/i18n/i18n';


import FieldMultilingualSelect from '../../SharedComponent/FieldMultilingualSelect/FieldMultilingualSelect';
import FieldSelect from '../../SharedComponent/FieldSelect/FieldSelect';
import FieldText from '../../SharedComponent/FieldText/FieldText';

export default class FieldSetLocation extends Component {

    constructor(props) {
        super(props);

        let country = this.props.setting.data.country.data.map(function (item) {
            return {
                id: item.id,
                name: item.nameLang,
            };
        });

        this.state = {
            country: country || [],
        };

        this.ui = {
            country: React.createRef(),
            region: React.createRef(),
            city: React.createRef(),
        };

        this.setError = this.setError.bind(this);
        this.loadRegionList = this.loadRegionList.bind(this);
        this.loadCityList = this.loadCityList.bind(this);
        this.setValue = this.setValue.bind(this);
        this.getFullValue = this.getFullValue.bind(this);
        this.getValue = this.getValue.bind(this);
        this.enabled = this.enabled.bind(this);
        this.countryEnabled = this.countryEnabled.bind(this);
        this.regionEnabled = this.regionEnabled.bind(this);
        this.cityEnabled = this.cityEnabled.bind(this);
        this.processCityName = this.processCityName.bind(this);
    }

    setError(message = '', errorFields = [],) {
        if (errorFields.length === 0) {
            this.ui.country.current.setError(message);
            this.ui.region.current.setError(message);
            this.ui.city.current.setError(message);
        } else {
            errorFields.forEach(item => {
                if (item === 'country') {
                    this.ui.country.current.setError(message);
                }
                if (item === 'region') {
                    this.ui.region.current.setError(message);
                }
                if (item === 'city') {
                    this.ui.city.current.setError(message);
                }
            });
        }
    }

    setValue(data) {
        this.ui.country.current.setValue(data.country.id || 0);
        this.ui.region.current.setValue(data.region.id || 0);
        this.ui.region.current.setData(data.region.data || []);
        this.ui.region.current.enabled(!!data.region.data);
        this.ui.city.current.setValue(data.city.name || '');
        this.ui.city.current.setData(data.city.data || []);
        this.ui.city.current.enabled(!!data.city.data);
    }

    processCityName(city) {
        let newCity = city.trim();
        newCity = newCity.replace(/\s\s+/g, ' ');
        newCity = newCity.replace(/^[город|Город]\./g, '');
        return newCity;
    }

    getFullValue() {
        let city = this.ui.city.current.inDataList(this.ui.city.current.getValue());
        return {
            country: {
                id: parseInt(this.ui.country.current.getValue()),
            },
            region: {
                id: parseInt(this.ui.region.current.getValue()),
                data: this.ui.region.current.getData(),
            },
            city: {
                id: (typeof city === 'undefined') ? 0 : city.id,
                name: this.processCityName(this.ui.city.current.getValue()),
                data: this.ui.city.current.getData(),
            },
        };
    }

    getValue() {
        let city = this.ui.city.current.inDataList(this.ui.city.current.getValue(), false);
        return {
            country: {
                id: parseInt(this.ui.country.current.getValue()),
            },
            region: {
                id: parseInt(this.ui.region.current.getValue()),
            },
            city: {
                id: (typeof city === 'undefined') ? 0 : city.id,
                name: this.processCityName(this.ui.city.current.getValue()),
            },
        };
    }

    enabled(enabled) {
        this.ui.country.current.enabled(enabled);
        this.ui.region.current.enabled(enabled);
        this.ui.city.current.enabled(enabled);
    }

    countryEnabled(enabled) {
        this.ui.country.current.enabled(enabled);
    }

    regionEnabled(enabled) {
        this.ui.region.current.enabled(enabled);
    }

    cityEnabled(enabled) {
        this.ui.city.current.enabled(enabled);
    }

    loadRegionList(countryId) {

        this.ui.region.current.showSpinner(true);

        fetch('api/request.php', {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            body: JSON.stringify({
                action: 'getRegionList',
                payload: {
                    countryId: parseInt(countryId),
                }
            })
        })
            .then(response => {
                return response.json();
            })
            .then(json => {
                this.ui.region.current.showSpinner(false);
                if (json.type !== 0) {
                    this.props.message.current.setMessage(json.code, 'danger', false);
                    return;
                }

                this.ui.region.current.enabled(true);
                this.ui.region.current.setData(json.data);

            })
            .catch(error => {
                debugger;
                this.ui.region.current.showSpinner(false);
                this.props.message.current.setMessage("ERR_UNKNOWN", 'danger', false);
            });
    }

    loadCityList(regionId) {

        this.ui.city.current.showSpinner(true);

        fetch('api/request.php', {
            method: 'POST',
            mode: 'cors',
            credentials: 'include',
            body: JSON.stringify({
                action: 'getCityListByRegion',
                payload: {
                    regionId: parseInt(regionId),
                }
            })
        })
            .then(response => {
                return response.json();
            })
            .then(json => {
                this.ui.city.current.showSpinner(false);
                if (json.type !== 0) {
                    this.props.message.current.setMessage(json.code, 'danger', false);
                    return;
                }

                this.ui.city.current.enabled(true);
                this.ui.city.current.setData(json.data);

            })
            .catch(error => {
                debugger;
                this.ui.city.current.showSpinner(false);
                this.props.message.current.setMessage("ERR_UNKNOWN", 'danger', false);
            });
    }

    render() {
        const {noRegionAndCity = false} = this.props;

        return (
            <div className="fb-row fb-s-e">
                <FieldMultilingualSelect ref={this.ui.country} setting={this.props.setting} option={{
                    label: "COUNTRY",
                    preData: [{id: 0, name: "CHOOSE_COUNTRY", disabled: true}],
                    sort: true,
                    data: this.state.country,
                    onChange: function (value) {
                        this.ui.region.current.enabled(false);
                        this.ui.region.current.setValue(0);

                        this.ui.city.current.enabled(false);
                        this.ui.city.current.setValue('');

                        this.loadRegionList(value);
                        this.props.option && this.props.option.onCountryChanged && this.props.option.onCountryChanged(value);
                        return true;
                    }.bind(this),
                }}/>
                {/*<FieldSelect ref={this.ui.country} setting={this.props.setting} option={{*/}
                {/*    label: "COUNTRY",*/}
                {/*    preData: [{id: 0, name: "CHOOSE_COUNTRY", disabled: true}],*/}
                {/*    data: this.state.country,*/}
                {/*    onChange: function (value) {*/}
                {/*        this.ui.region.current.enabled(false);*/}
                {/*        this.ui.region.current.setValue(0);*/}

                {/*        this.ui.city.current.enabled(false);*/}
                {/*        this.ui.city.current.setValue('');*/}

                {/*        this.loadRegionList(value);*/}
                {/*        this.props.option && this.props.option.onCountryChanged && this.props.option.onCountryChanged(value);*/}
                {/*        return true;*/}
                {/*    }.bind(this),*/}
                {/*}}/>*/}
                <div className={noRegionAndCity ? 'hidden' : ''}>
                    <FieldSelect ref={this.ui.region} setting={this.props.setting} option={{
                        label: "REGION",
                        preData: [{id: 0, name: "CHOOSE_REGION", disabled: true}],
                        enabled: false,
                        hasSpinner: true,
                        onChange: function (value) {
                            this.ui.city.current.enabled(false);
                            this.ui.city.current.setValue('');

                            this.loadCityList(value);
                            this.props.option && this.props.option.onRegionChanged && this.props.option.onRegionChanged(value);
                            return true;
                        }.bind(this),
                    }}/>
                </div>
                <div className={noRegionAndCity ? 'hidden' : ''}>
                    <FieldText ref={this.ui.city} setting={this.props.setting} option={{
                        label: "CITY",
                        type: "text",
                        enabled: false,
                        hasSpinner: true,
                        onChange: function (value) {
                            const check = /^[a-zA-Zа-яА-Я\s-]*$/.test(value);
                            if (!check) return false;
                            let city = this.ui.city.current.inDataList(value);
                            this.props.option && this.props.option.onCityChanged && this.props.option.onCityChanged(city ? city.id : 0, value);
                            return true;
                        }.bind(this),
                    }}/>
                </div>
            </div>
        );
    }

}